import { Version } from '@angular/core';

/** Current version of the Angular Component Development Kit. */
const VERSION = new Version('16.2.14');

export { VERSION };
